import { useState } from "react";
import React from "react";
import { IoMdClose } from "react-icons/io";
import styled from "styled-components";
import { useIsDesktop } from "../../hooks/useIsDesktop";

const Wrapper = styled.div`
  width: 100%;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`;

const CloseIcon = styled(IoMdClose)`
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
`;

const Paragraph = styled.p`
  color: white;
  margin: 1px;
  padding: 0;
  font-size: 1.3rem;
  &:first-of-type {
    margin-top: 1rem;
  }
  &:last-of-type {
    margin-bottom: 1rem;
  }
`;

export interface BannerProps {
  type: "mobile" | "desktop";
}

export const Banner: React.FC<BannerProps> = ({ type }) => {
  const [visible, setVisible] = useState(true);
  const isDesktop = useIsDesktop();

  if (!visible) return null;

  if ((type === "desktop" && !isDesktop) || (type == "mobile" && isDesktop))
    return null;

  return (
    <Wrapper>
      {isDesktop && (
        <CloseIcon color="black" size={20} onClick={() => setVisible(false)} />
      )}
      <Paragraph>NEW ITEMS NOW AVAILABLE</Paragraph>
      <Paragraph>FREE SHIPPING OVER €120</Paragraph>
    </Wrapper>
  );
};
